var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-row", [
        _c(
          "div",
          {
            staticClass: "layout-invoice"
          },
          [
            _c(
              "v-container",
              {
                attrs: {
                  fluid: ""
                }
              },
              [
                !_vm.loading
                  ? [
                      _c("invoice-body", {
                        attrs: {
                          loading: _vm.loading,
                          invoice: _vm.invoice,
                          contact: _vm.contact,
                          text: ""
                        }
                      }),
                      _vm.payments.length
                        ? _c("invoice-history", {
                            attrs: {
                              payments: _vm.payments,
                              text: ""
                            }
                          })
                        : _vm._e()
                    ]
                  : _c("v-progress-linear", {
                      attrs: {
                        indeterminate: true
                      }
                    })
              ],
              2
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }